import {createApp} from 'vue'
import './style.css'
import App from './App.vue'
import router from './router'
import {createPinia} from 'pinia'
import piniaPersist from 'pinia-plugin-persistedstate'
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import zhTw from 'element-plus/es/locale/lang/zh-tw'
import fadeIn from './directive'
import money from './directive/money.js'
import number from './directive/number.js'
import httpPlugin from './utils/http.js'
import i18n from '@/locales/i18n.js'
import '@/assets/css/mobile.scss'
import Vant from 'vant'
import 'vant/lib/index.css'
import { getTimeDiff,formatTime } from './utils/tool.js'
const app = createApp(App)
const pinia = createPinia();
pinia.use(piniaPersist)
app.use(router)
app.use(pinia)
app.use(ElementPlus, { locale: zhTw })
app.directive('fade-in', fadeIn)
app.directive('money', money)
app.directive('number', number)
app.config.globalProperties.$getTimeDiff = getTimeDiff
app.config.globalProperties.$formatTime = formatTime
app.use(httpPlugin)
app.use(i18n)
app.use(Vant)
app.mount('#app')
